<div class="profile-completion-card">
  <h2>Complete Your Profile</h2>
  <p class="subtitle">Please provide the following details to continue</p>

  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstname" />
        <mat-error *ngIf="profileForm.get('firstname')?.invalid && profileForm.get('firstname')?.touched">
          First name is required (min 2 characters)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastname" />
        <mat-error *ngIf="profileForm.get('lastname')?.invalid && profileForm.get('lastname')?.touched">
          Last name is required (min 2 characters)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Country</mat-label>
        <mat-select formControlName="country">
          <mat-option value="">-- Select Country --</mat-option>
          <mat-option *ngFor="let country of countries" [value]="country.code">
            {{ country.name }} ({{ country.code }})
          </mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.get('country')?.invalid && profileForm.get('country')?.touched">
          Country is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>University</mat-label>
        <input matInput formControlName="university" />
        <mat-error *ngIf="profileForm.get('university')?.invalid && profileForm.get('university')?.touched">
          University is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Major</mat-label>
        <input matInput formControlName="major" />
        <mat-error *ngIf="profileForm.get('major')?.invalid && profileForm.get('major')?.touched">
          Major is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Graduation Year</mat-label>
        <input matInput formControlName="graduationYear" />
        <mat-error *ngIf="profileForm.get('graduationYear')?.invalid && profileForm.get('graduationYear')?.touched">
          Graduation year must be a 4-digit number
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Degree Level</mat-label>
        <mat-select formControlName="degreeLevel">
          <mat-option value="">-- Select Degree Level --</mat-option>
          <mat-option value="Bachelor">Bachelor</mat-option>
          <mat-option value="Master">Master</mat-option>
          <mat-option value="PhD">PhD</mat-option>
          <mat-option value="Other">Other</mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.get('degreeLevel')?.invalid && profileForm.get('degreeLevel')?.touched">
          Degree level is required
        </mat-error>
      </mat-form-field>

    <div class="error-alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <button
      type="submit"
      mat-flat-button
      color="primary"
      class="btn-submit"
      [disabled]="loading || profileForm.invalid"
    >
      {{ loading ? 'Saving...' : 'Continue' }}
    </button>
  </form>
</div>
